import { environment } from 'src/environments/environment';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.COGNITO_USER_POOL_ID,
      userPoolClientId: environment.COGNITO_CLIENT_ID,
    },
  },
};
